import { Grid } from '@material-ui/core';
import Button from 'components/Button/Button';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectRecordAllowancesOfSelectedRecord } from 'store/recordAllowances/selectors/record-and-employer-allowances.selectors';
import { selectSelectedRecordAllowanceRecordsWithEditAttributes } from 'store/records/selectors/records.selectors';
import { AllowanceRecordsTimePicker } from '../AllowanceRecordsTimePicker';
import { AddRecordAllowanceDialog } from './AddRecordAllowanceDialog/AddRecordAllowanceDialog';
import { RecordAllowancesList } from './RecordAllowancesList/RecordAllowancesList';

export const RecordAllowances = ({
  parentClockIn,
  parentClockOut,
  disabled,
}) => {
  const selectedRecordAllowances = useSelector(
    selectRecordAllowancesOfSelectedRecord
  );

  const allowanceRecords = useSelector(
    selectSelectedRecordAllowanceRecordsWithEditAttributes
  );

  const [isAddAllowanceDialogOpen, setIsAddAllowanceDialogOpen] =
    useState(false);

  const { t } = useTranslation('common');

  const selectedRecordAllowancesCount = selectedRecordAllowances?.length || 0;

  const selectedRecordAllowancesRecordsCount = allowanceRecords?.length || 0;

  return (
    <>
      <Grid item xs={12}>
        <label className="mylabel">
          {`${'Merkinnän lisät'} (${
            selectedRecordAllowancesCount + selectedRecordAllowancesRecordsCount
          })`}
        </label>
      </Grid>
      {allowanceRecords.map((allowanceRecord) => (
        <AllowanceRecordsTimePicker
          key={allowanceRecord.id}
          allowanceRecord={allowanceRecord}
          disabled={disabled}
          parentClockIn={parentClockIn}
          parentClockOut={parentClockOut}
        ></AllowanceRecordsTimePicker>
      ))}
      {selectedRecordAllowances && selectedRecordAllowances.length > 0 ? (
        <RecordAllowancesList
          recordAllowances={selectedRecordAllowances}
          disabled={disabled}
        ></RecordAllowancesList>
      ) : null}

      <div style={{ width: '100%', textAlign: 'right' }}>
        <Button
          onClick={() => setIsAddAllowanceDialogOpen(true)}
          color="primary"
          disabled={disabled}
        >
          {t('calendar.add_allowance')}
        </Button>
      </div>

      {isAddAllowanceDialogOpen ? (
        <AddRecordAllowanceDialog
          onClose={() => setIsAddAllowanceDialogOpen(false)}
          parentClockIn={parentClockIn}
          parentClockOut={parentClockOut}
        ></AddRecordAllowanceDialog>
      ) : null}
    </>
  );
};
